var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vivo-wrap"},[_c('div',{ref:"host",staticClass:"vivo-host"}),(_vm.error)?_c('p',{staticClass:"vivo-error"},[_vm._v(" No pudimos cargar la simulación. Inicia sesión y crea una planificación de verdad: es más rápido que verla. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }